import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["errorMessage", "invalid", "label", "size"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import cn from 'clsx';
import { FormField } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Textarea = function Textarea(props) {
  var errorMessage = props.errorMessage,
    invalid = props.invalid,
    label = props.label,
    size = props.size,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(FormField, {
    errorMessage: errorMessage,
    label: label,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx("textarea", _objectSpread(_objectSpread({}, rest), {}, {
      className: cn(styles['textarea'], styles["textarea-size_".concat((size || 'M').toLowerCase())], invalid && styles['invalid'], props.className)
    }))
  });
};
Textarea.displayName = 'Textarea';